export const MEDIA_UPLOAD_PROTOCOL_ID = 'MediaUpload';